import type { ComponentType, FunctionComponent, PropsWithChildren } from 'react'
import React, { Fragment } from 'react'
import { RawIntlProvider } from 'react-intl'
import { Provider as StoreProvider, useSelector } from 'react-redux'

import { OverflowProvider } from '@app/utils/OverflowContext'

import { intlSelector } from '@app/store/slices/intl'
import type { Store } from '@app/store/store'

import { AppStackContextProvider } from '@app/components/AppStackContextProvider/AppStackContextProvider'
import { BrowserRenderProvider } from '@app/components/BrowserRenderContext/BrowserRenderContext'
import { LayoutMilkStateContextProvider } from '@app/components/LayoutMilk/LayoutMilkStateContext'
import { MenuPortalProvider } from '@app/components/Menu/MenuPortalContext'

export const ContextProvider: FunctionComponent<{ store: Store; suspense?: ComponentType<PropsWithChildren>; children?: React.ReactNode }> = ({
  store,
  suspense: SuspenseSlot = Fragment,
  children,
}) => {
  return (
    <StoreProvider store={store}>
      <AppIntlProvider>
        <SuspenseSlot>
          <BrowserRenderProvider>
            <AppStackContextProvider>
              <LayoutMilkStateContextProvider>
                <OverflowProvider>
                  <MenuPortalProvider>{children}</MenuPortalProvider>
                </OverflowProvider>
              </LayoutMilkStateContextProvider>
            </AppStackContextProvider>
          </BrowserRenderProvider>
        </SuspenseSlot>
      </AppIntlProvider>
    </StoreProvider>
  )
}

const AppIntlProvider: FunctionComponent<{ children?: React.ReactNode }> = ({ children }) => {
  const intl = useSelector(intlSelector)

  return <RawIntlProvider value={intl}>{children}</RawIntlProvider>
}
